import clsx from "clsx";
import NextLink from "next/link";
import { Chevron } from "./chevron";
export const BreadCrumbItem = ({
  items,
  href,
  children,
  onClick,
}: {
  items: any;
  href: string;
  children: React.ReactNode;
  onClick?: () => void;
}) => {
  const isLastOne =
    items.length - 1 === items.findLastIndex(({ text: itemText }: { text: any }) => itemText === children);

  return (
    <NextLink href={href} onClick={onClick} className={!href && !onClick ? "pointer-events-none" : "cursor-pointer"}>
      <div
        className={clsx("flex items-center", {
          "font-bold text-brand-primary": isLastOne,
        })}
      >
        {children}
        {!isLastOne && <Chevron />}
      </div>
    </NextLink>
  );
};
